import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './address-box.module.scss';

const AddressBox = ({ address, quantity, isSelected = false, className }) => {
    const { t } = useTranslation()

    return (
        <div className={`${styles.addressBox} ${className ?? ''} ${isSelected ? styles.addressBoxSelected : ''}`}>
            {/* <div className={styles.header}>{address?.street}</div> */}
            <div className={styles.header}><img src='/icons/add-location.svg' />{t("Address")}</div>
            <div className={styles.content}>
                {address?.company && <div className={styles.value}>{address.company}</div>}
                {address?.street && <div className={styles.value}>{address.street}</div>}
                {address?.street_number && <div className={styles.value}>{address.street_number}</div>}
                {address?.additional_field_1 && <div className={styles.value}>{address.additional_field_1}</div>}
                {address?.additional_field_2 && <div className={styles.value}>{address.additional_field_2}</div>}
                {address?.zipcode && <div className={styles.value}>{address.zipcode}</div>}
                {address?.city && <div className={styles.value}>{address.city}</div>}
                {address?.county && <div className={styles.value}>{address.county}</div>}
                {address?.country?.name && <div className={styles.value}>{address.country.name}</div>}
            </div>
            {/* <div className={styles.content}>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{t('Street')}:</span>
                    <span className={styles.fieldValue}>{address?.street}</span>
                </div>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{t('Street No.')}: </span>
                    <span className={styles.fieldValue}>{address?.street_number}</span>
                </div>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{t('Additional Field')}:</span>
                    <span className={styles.fieldValue}>{address?.additional_field_1}</span>
                </div>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{t('Additional Field 2')}:</span>
                    <span className={styles.fieldValue}>{address?.additional_field_2}</span>
                </div>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{t('Zipcode')}:</span>
                    <span className={styles.fieldValue}>{address?.zipcode}</span>
                </div>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{t('City')}:</span>
                    <span className={styles.fieldValue}>{address?.city}</span>
                </div>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{t('County')}:</span>
                    <span className={styles.fieldValue}>{address?.county}</span>
                </div>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{t('Country')}:</span>
                    <span className={styles.fieldValue}>{address?.country?.name}</span>
                </div>
            </div> */}
        </div>
    );
};


AddressBox.propTypes = {
    address: PropTypes.shape({
        id: PropTypes.number.isRequired,
        company: PropTypes.string,
        street: PropTypes.string.isRequired,
        street_number: PropTypes.string,
        city: PropTypes.string.isRequired,
        county: PropTypes.string,
        country_id: PropTypes.number.isRequired,
        zipcode: PropTypes.string.isRequired,
    }).isRequired,
    className: PropTypes.string,
    isSelected: PropTypes.bool,
}

export default AddressBox